import Loader from '../Common/Loader';

const Loading = () => {
    return (
        <div className="w-full flex justify-center items-center border border-border rounded-md py-14 bg-white shadow">
            <Loader />
        </div>
    );
}

export default Loading;